<template>
  <b-card>
    <div class="d-flex justify-content-between">
      <div>
        <template v-if="!in_edition">
          <div>
            <span class="h4"> {{ local_value.typename }} </span>
            <ul>
              <li>
                {{ $t('category') }}
                <b>
                  {{ local_value.metavariable_type.constructor.category }}
                </b>
              </li>

              <li
                v-if="
                  local_value.metavariable_type.constructor.category ===
                    'enumeration'
                "
              >
                {{ $t('values') }} :
                <ul>
                  <li
                    v-for="enum_value in local_value.metavariable_type.values"
                  >
                    {{ enum_value }}
                  </li>
                </ul>
              </li>

              <!--             <template v-if="local_value.category === 'numeric'">
                <li>{{ $t('start') }} {{ local_value.start }}</li>
                <li>{{ $t('stop') }} {{ local_value.stop }}</li>
                <li>{{ $t('step') }} {{ local_value.step }}</li>
              </template>
    }
 -->
              <!--               <li v-if="local_value.category === 'temporal'">
                {{ $t('definition') }} {{ local_value.rrulestr }}
              </li> -->

              <template
                v-if="
                  local_value.metavariable_type.constructor.category ===
                    'temporal'
                "
              >
                <li>
                  {{ 'Rrule' }} : {{ local_value.metavariable_type.rrulestr }}
                </li>
                <li>
                  {{ 'Format' }} :
                  {{ local_value.metavariable_type.display_format }}
                </li>
                <li>
                  {{ $t('use_previous_period') }} :
                  {{ local_value.metavariable_type.use_previous_period }}
                </li></template
              >
            </ul>
          </div>
        </template>

        <template v-else>
          <b-row align-v="end" class="mb-3">
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b> {{ $t('name') }} :</b>
                </label>
                <b-form-input v-model="local_value.typename" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b> {{ $t('category') }} :</b>
                </label>
                <b-form-select
                  :value="category"
                  :options="categories"
                  @input="category_changed"
                />
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-btn
                v-if="is_new_metavariable_type"
                variant="outline-secondary"
                @click="validate_edition"
              >
                <span class="fas fa-plus fa-fw" />
              </b-btn>
              <b-btn-group v-else>
                <b-btn @click="toggle_edition" variant="outline-secondary">
                  <span class="fas fa-fw fa-check" />
                </b-btn>
                <b-btn @click="delete_button_on" variant="outline-secondary">
                  <span class="fas fa-fw fa-times" />
                </b-btn>
              </b-btn-group>
            </b-col>
          </b-row>

          <!--           <b-row v-if="category === 'numeric'">
            <b-col>
              <b-form-group>
                <label> {{ $t('start') }} : </label>
                <b-form-input v-model="local_value.start" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label> {{ $t('stop') }} : </label>
                <b-form-input v-model="local_value.stop" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label> {{ $t('step') }} : </label>
                <b-form-input v-model="local_value.step" />
              </b-form-group>
            </b-col>
          </b-row> -->

          <b-row v-if="category === 'enumeration'">
            <b-col cols="3">
              <div v-if="!_.isEmpty(local_value.metavariable_type.values)">
                <span>{{ $t('values') }} :</span>
                <b-list-group>
                  <b-list-group-item
                    v-for="enumeration_value in local_value.metavariable_type
                      .values"
                  >
                    {{ enumeration_value }}
                  </b-list-group-item>
                </b-list-group>
              </div>
              <b-form-group>
                <label> {{ $t('add_value') }} : </label>
                <b-input-group>
                  <b-form-input v-model="new_enum_input_value" />
                  <b-input-group-append>
                    <b-btn
                      variant="outline-secondary"
                      @click="add_new_metavariable_enum_input_value"
                    >
                      <span class="fas fa-plus fa-fw" />
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <template v-if="category === 'temporal'">
            <b-row>
              <b-col cols="10">
                <b-form-group>
                  <label>
                    <b> {{ 'Rrule' }} : </b>
                    <span
                      v-c-tooltip="$t('rrule_tooltip')"
                      class="fas fa-question-circle"
                    />
                  </label>
                  <b-form-textarea
                    v-model="local_value.metavariable_type.rrulestr"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="10">
                <b-form-group>
                  <label>
                    <b> {{ 'Format' }} : </b>
                    <span
                      v-c-tooltip="$t('format_tooltip')"
                      class="fas fa-question-circle"
                    />
                  </label>
                  <b-form-input
                    v-model="local_value.metavariable_type.display_format"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-checkbox
                  switch
                  v-model="local_value.metavariable_type.use_previous_period"
                  :value="true"
                  :unchecked-value="false"
                >
                  {{ $t('use_previous_period') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </template>
        </template>
      </div>
      <div v-if="!in_edition">
        <b-btn-group>
          <b-btn @click="toggle_edition" variant="outline-secondary">
            <span class="fas fa-fw fa-pen" />
          </b-btn>
          <b-btn @click="delete_button_on" variant="outline-secondary">
            <span class="fas fa-fw fa-trash" />
          </b-btn>
        </b-btn-group>
      </div>
    </div>
  </b-card>
</template>

<i18n>
{
  "en": {
    "enumeration": "Enumeration",
    "boolean": "Boolean",
    "numeric": "Numeric",
    "temporal": "Temporal",
    "definition": "Definition",
    "rrule_tooltip": "At the rrulestr format, see documentation at https://dateutil.readthedocs.io/en/stable/rrule.html",
    "format_tooltip": "At the strftime format, see documentation at https://docs.python.org/3/library/datetime.html#strftime-and-strptime-format-codes",
    "use_previous_period": "End of period handling (deactivated means use period start date, activated means use period stop date)",
    "values": "Values",
    "value": "Value",
    "add_value": "Add Value"
  },
  "fr": {
    "enumeration": "Énumération",
    "boolean": "Booléen",
    "numeric": "Numérique",
    "temporal": "Temporelle",
    "definition": "Définition",
    "rrule_tooltip": "Au format rrulestr, voir la documentation https://dateutil.readthedocs.io/en/stable/rrule.html",
    "format_tooltip": "Au format strftime, voir la documentation https://docs.python.org/3/library/datetime.html#strftime-and-strptime-format-codes",
    "use_previous_period": "Gestion de la fin de période (désactivé pour utiliser la date de début de période, activé pour utiliser la date de fin de période)",
    "values": "Valeurs",
    "value": "Valeur",
    "add_value": "Ajouter une valeur"
  }
}
</i18n>

<script>
import _ from 'lodash'
import {
  MetavariableCategoryToString,
  MetavariableTypeAbstractBase,
  MetavariableTypeEnumerationCategory,
  // MetavariableTypeBooleanCategory,
  // MetavariableTypeNumericCategory,
  MetavariableTypeTemporalCategory,
} from '@/components/object_model.js'

// *****************************************************************************

export default {
  name: 'MetavariableTypeElement',
  props: ['value', 'is_new_metavariable_type', 'in_edition'],

  data() {
    return {
      local_value: undefined,
      category: 'unknown',

      // stop_type: 'count',

      // stop_type_options: [
      //   { value: 'count', text: 'count' },
      //   { value: 'until', text: 'until' },
      // ],

      new_enum_input_value: '',

      category_to_constructor: {
        unknown: MetavariableTypeAbstractBase,
        enumeration: MetavariableTypeEnumerationCategory,
        // boolean: MetavariableTypeBooleanCategory,
        // numeric: MetavariableTypeNumericCategory,
        temporal: MetavariableTypeTemporalCategory,
      },
    }
  },

  computed: {
    _() {
      return _
    },

    categories() {
      let res = [
        { value: 'unknown', text: this.$t('unknown') },
        { value: 'enumeration', text: this.$t('enumeration') },
        // { value: 'boolean', text: this.$t('boolean') },
        // { value: 'numeric', text: this.$t('numeric') },
        { value: 'temporal', text: this.$t('temporal') },
      ]
      return res
    },
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.local_value = _.cloneDeep(nv)
          // this.category = this.local_value.category
          this.category = this.local_value.metavariable_type.constructor.category
        }
      },
    },
    in_edition(nv) {
      if (nv) {
        // this.category = this.local_value.category
        this.category = this.local_value.metavariable_type.constructor.category
      }
    },
    // local_value: {
    //   immediate: true,
    //   deep: true,
    //   handler(nv, ov) {
    //     if (!_.isEqual(nv, ov)) {
    //       this.$emit('input', _.cloneDeep(nv))
    //     }
    //   },
    // },
  },

  methods: {
    validate_edition() {
      if (!(this.local_value[0] === '')) {
        this.$emit('input', _.cloneDeep(this.local_value))
        this.category = 'unknown'
      }
    },

    category_changed(value) {
      this.category = value
      // this.local_value = new this.category_to_constructor[value](
      //   this.local_value.typename
      // )
      this.local_value = {
        typename: this.local_value.typename,
        metavariable_type: new this.category_to_constructor[value](),
      }
    },

    add_new_metavariable_enum_input_value() {
      if (this.new_enum_input_value !== '') {
        this.local_value.metavariable_type.values.push(
          this.new_enum_input_value
        )
        this.new_enum_input_value = ''
      }
    },

    toggle_edition() {
      if (this.in_edition) {
        this.validate_edition()
      } else {
        this.$emit('start_editing')
      }
    },

    delete_button_on() {
      this.$emit('delete')
    },
  },
}
</script>
